import moment from 'moment';

export const isInOneMonth = (startAt, endAt) => {
  if (startAt === undefined || endAt === undefined) {
    return false;
  }

  // https://redmine.pklotcorp.com/issues/92581
  // 最後決定一個月定義為 31 天
  const maxEndAt = moment(startAt)
    .add(31, 'day')
    .subtract(1, 'day')
    .endOf('day');

  return moment.parseZone(endAt).isSame(maxEndAt) || moment.parseZone(endAt).isBefore(maxEndAt);
};
